import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, VStack, Text, Button, HStack } from '@chakra-ui/react';

// ============================================================================
// WELCOME PAGE - Shown after onboarding, offers tutorial
// ============================================================================
// This replaces the modal popup that was causing render loops on PC
// Clean navigation: /onboarding → /welcome → / (or tutorial)
// ============================================================================

const WelcomePage: React.FC = () => {
  const navigate = useNavigate();

  const handleStartTutorial = () => {
    // Navigate to home with tutorial param
    navigate('/?startTutorial=true', { replace: true });
  };

  const handleSkip = () => {
    // Just go to home
    navigate('/', { replace: true });
  };

  return (
    <Box
      minH="100vh"
      bg="#0D1B2A"
      display="flex"
      alignItems="center"
      justifyContent="center"
      p={4}
    >
      <Box
        maxW="450px"
        w="100%"
        bg="gray.800"
        borderRadius="xl"
        border="1px solid"
        borderColor="cyan.500"
        overflow="hidden"
        boxShadow="0 0 40px rgba(0, 217, 217, 0.2)"
      >
        {/* Header */}
        <Box
          bg="linear-gradient(135deg, rgba(0, 217, 217, 0.2) 0%, rgba(0, 217, 217, 0.05) 100%)"
          p={6}
          textAlign="center"
        >
          <Text fontSize="5xl" mb={2}></Text>

          <Text fontSize="2xl" fontWeight="bold" color="white">
            Welcome to PokerSweepStars!
          </Text>
          <Text color="cyan.400" fontSize="md" mt={1}>
            Your account is ready
          </Text>
        </Box>

        {/* Content */}
        <VStack spacing={4} p={6} textAlign="center">
          <Text color="gray.300" fontSize="md">
            Would you like a quick tour of the app?
          </Text>
          <Text color="gray.500" fontSize="sm">
            Learn how to play, earn PSS Coins, and get the most out of your experience.
          </Text>

          {/* Features Preview */}
          <Box
            w="100%"
            bg="gray.700"
            borderRadius="lg"
            p={4}
            mt={2}
          >
            <VStack spacing={3} align="start">
              <HStack spacing={3}>
                <Text fontSize="xl"></Text>

                <Text color="gray.300" fontSize="sm">Learn the training center</Text>
              </HStack>
              <HStack spacing={3}>
                <Text fontSize="xl"></Text>

                <Text color="gray.300" fontSize="sm">Understand PSS Coins & PlayCoins</Text>
              </HStack>
              <HStack spacing={3}>
                <Text fontSize="xl"></Text>

                <Text color="gray.300" fontSize="sm">Find and join tables</Text>
              </HStack>
              <HStack spacing={3}>
                <Text fontSize="xl"></Text>

                <Text color="gray.300" fontSize="sm">Voice & video chat features</Text>
              </HStack>
            </VStack>
          </Box>

          <Text color="gray.600" fontSize="xs" mt={2}>
            Takes about 2 minutes • You can always restart from Profile
          </Text>
        </VStack>

        {/* Buttons */}
        <HStack p={6} pt={2} spacing={3} justify="center">
          <Button
            variant="ghost"
            color="gray.400"
            size="lg"
            onClick={handleSkip}
            _hover={{ color: 'white', bg: 'gray.700' }}
          >
            Skip for Now
          </Button>
          <Button
            colorScheme="cyan"
            size="lg"
            onClick={handleStartTutorial}
            px={8}
          >
            Start Tour 

          </Button>
        </HStack>
      </Box>
    </Box>
  );
};

export default WelcomePage;